<template>
	<div 
		class="image-gallery"
		@keyup.left="changeSlide('prev')"
		@keyup.right="changeSlide('next')"
	>
		<button @click="changeSlide('prev')" type="button" class="gallery-control" aria-label="Previous Image" title="Previous"><i class="fa fa-chevron-left"></i></button>
		<div class="image-slide-container">
			<transition
				v-on:beforeEnter="beforeEnter"
				v-on:enter="enter"
				v-on:leave="leave"
				v-bind:css="false"
				mode="out-in"
			>
				<div v-if="currentSlideIndex === index" v-for="(image, index) in images" :key="index" class="image-slide">
					<img :src="baseUrl + image.src" :alt="image.alt"/>
				</div>
			</transition>
			<!-- <transition-group
				tag="div"
				v-on:beforeEnter="beforeEnter"
				v-on:enter="enter"
				v-on:leave="leave"
				v-bind:css="false"
				v-show="currentSlideIndex === image.index"
			>
				<div v-for="image in imageSlides" :key="image.index">
					<div v-show="currentSlideIndex === image.index"  class="image-slide">
						<img :src="baseUrl + image.src" :alt="image.alt"/>
					</div>
				</div>
			</transition-group> -->
		</div>
		<div class="bullet-container">
			<button type="button" :class="{'is-active': currentSlideIndex === index}" v-for="(image, index) in images" :key="index" @click="currentSlideIndex = index" :title="(index+1)+' of '+images.length" :aria-label="'Slide '+(index+1)+' of '+images.length"></button>
		</div>
		<button @click="changeSlide('next')" type="button" class="gallery-control" aria-label="Next Image" title="Next"><i class="fa fa-chevron-right"></i></button>
	</div>
</template>

<script>
import Velocity from 'velocity-animate'

export default {
	name: 'ImageGallery',
	props: {
		images: {
			type: Array,
			required: true,
			default() {
				return []
			}
		}
	},
	data() {
		return {
			itemid: 0,
			currentSlideIndex: 0,
			isChangingSlides: false,
			baseUrl: process.env.BASE_URL
		}
	},
	methods: {
		preloadImages() {
			for (let i=0; i<this.images.length; i++) {
				const img = new Image();
				img.src = this.images[i].src;
				console.log(img);
			}
		},
		changeSlide(direction) {
			if (!this.isChangingSlides) {
				if (direction === 'next') {
					if (this.currentSlideIndex == this.images.length - 1) {
						this.currentSlideIndex = 0;
					}
					else {
						this.currentSlideIndex++;
					}
				}
				else if (direction === 'prev') {
					if (this.currentSlideIndex == 0) {
						this.currentSlideIndex = this.images.length - 1;
					}
					else {
						this.currentSlideIndex--;
					}
				}
			}
		},
		beforeEnter: function (el) {
			el.style.opacity = 0
		},
		enter: function (el, done) {
			this.isChangingSlides = true
			const vm = this
			Velocity(el, 'fadeIn',
				{
					duration: 300,
					// delay: 300,
					complete: function() {
						vm.isChangingSlides = false
						done()
					}
				}
			);
		},
		leave: function (el, done) {
			this.isChangingSlides = true
			const vm = this
			Velocity(el, 'fadeOut', 300, function() {
				vm.isChangingSlides = false
				done()
			});
		}
	},
	/*computed: {
		imageSlides() {
			var imageSlides = [];
			for (let i=0; i<this.images.length; i++) {
				let image = this.images[i];
				image.index = i;
				imageSlides.push(image);
			}
			return imageSlides;
		}
	},*/
	mounted() {
		this.preloadImages();
	},
	watch: {
		images() {
			this.preloadImages();
		}
	}
} 
</script>

<style lang="scss">
@import 'src/assets/css/modules/all';

.image-gallery {
	background-color: #333;
	display:block;
	height: 0;
	margin: 0 0 3rem;
	padding-bottom: 56.25%;
	position: relative;
	.gallery-control {
		@include buttonReset;
		background-color: #000;
		border-radius: 50%;
		color: #fff;
		display: inline-block;
		font-size: 2rem;
		height: 3.25rem;
		opacity: 0.5;
		padding: 0.5rem;
		position: absolute;
		top: calc(50% - 1.75rem);
		transition: 0.3s all;
		width: 3.25rem;
		z-index: 2;
		&:first-child {
			left: 1rem;
		}
		&:last-child {
			right: 1rem;
		}
		&:hover, &:focus {
			opacity: 0.8;
		}
	}
	.image-slide-container {
		height: 100%;
		left: 0;
		overflow: hidden;
		position: absolute;
		top: 0;
		width: 100%;
	}
	.image-slide {
		height: 100%;
		left: 0;
		position: absolute;
		top: 0;
		text-align: center;
		width: 100%;
		img {
			max-height: 100%;
			max-width: 100%;
		}
	}
	.bullet-container {
		bottom: -1.5rem;
		left: 0;
		position: absolute;
		text-align: center;
		width: 100%;
		button {
			@include buttonReset('#fff');
			border-radius: 50%;
			border: 2px solid #333;
			display: inline-block;
			height: 0.75rem;
			margin: 0 0.375rem;
			transition: 0.3s background-color;
			width: 0.75rem;
			&:hover, &:focus, &.is-active {
				background-color: #333; 
			}
		}
	}
}
</style>